












// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { toSubArray } from '@/utils/groupBy'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import EditBaseFlux from './EditBaseFlux.vue'

@Component({
  name: 'EditProfilExclusions',    
  components:{EditBaseFlux}
})
export default class EditProfilExclusions extends Vue {
  
  private flux = getDefaultAloFlux()
  
  edit(item:AloFlux) {    
    this.flux = (this.$refs.baseEdit as EditBaseFlux).edit(item)
  }  

  get profilExclusionList() {
    //@ts-ignore    
    return this.$store.myGetters.profilExclusionList
  }

  get profilExclusionGroup(){
    return toSubArray(this.profilExclusionList,3)
  }
}
